import { Task, TasksQueue } from '@apia/util';

export type TQueriesActionsChain =
  | 'directDeleteFilters'
  | 'directLoadSavedFilters'
  | 'directLoadStructure'
  | 'directPage'
  | 'directRefresh'
  | 'directSearch'
  | 'directSetFilters'
  | 'directSort'
  | 'directUpdateData'
  | 'directUpdateFilters'
  | 'fromRefresh'
  | 'fromSearchfromRefresh'
  | 'fromSearch'
  | 'fromSort'
  | 'fromUpdateFilters'
  | 'fromSearchfromUpdateFilters';

class QueriesQueue<
  QAT extends string = TQueriesActionsChain,
> extends TasksQueue {
  action: QAT | null = null;

  async runAction<T>(
    action: QAT,
    task: Task<T>,
    accepts?: Array<QAT | null>,
  ): Promise<T | undefined> {
    if (action !== this.action && !accepts?.includes(this.action)) {
      return await super.run(async () => {
        try {
          this.action = action;
          return await task();
        } finally {
          this.action = null;
        }
      });
    }

    return task();
  }
}

const queriesQueue = new QueriesQueue();

window.queriesQueue = queriesQueue as any;
export default queriesQueue;
